import { Boxes, Workflow, LayoutDashboard, Smartphone, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BrandExperience } from "./BrandExperience";

interface Props {
  onContinue: () => void;
}

const FEATURE_ICONS = [Boxes, Workflow, LayoutDashboard, Smartphone] as const;
const FEATURE_KEYS = ["Entities", "Workflows", "Dashboards", "Mobile"] as const;

/** Pantalla de bienvenida mostrada solo fuera de Electron (es decir, en studio.blackrednow.com
 *  o en la app Android) antes de pedir la URL/clave del backend. Explica qué es BlackRed Studio
 *  a alguien que llega por primera vez, y da paso a `RemoteConnectGate` al continuar. */
export function IntroLanding({ onContinue }: Props) {
  const { t } = useTranslation();

  return (
    <section className="view intro-landing">
      <div className="intro-stage">
        <div className="intro-hero">
          <span className="eyebrow">{t("intro.eyebrow")}</span>
          <h1>{t("intro.title")}</h1>
          <p>{t("intro.subtitle")}</p>
          <button className="btn primary large intro-cta" onClick={onContinue}>
            {t("intro.start")} <ArrowRight size={16} />
          </button>
        </div>
        <BrandExperience />
      </div>

      <div className="intro-features">
        {FEATURE_KEYS.map((key, index) => {
          const Icon = FEATURE_ICONS[index];
          return (
            <button className="card intro-feature" key={key} type="button" onClick={onContinue}>
              <Icon size={20} />
              <span><h3>{t(`intro.feature${key}Title`)}</h3><p>{t(`intro.feature${key}Body`)}</p></span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
